export default {
  id: null,
  cargoId: null,
  matricula: null,
  pessoa: null,
  usuario: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/employeemodel.js